var _style, _path, _path2, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _g6, _circle7, _g7, _circle8, _g8, _circle9, _g9, _circle10, _g10, _circle11, _g11, _circle12, _g12, _circle13, _g13, _circle14, _g14, _circle15, _g15, _rect, _path3, _g16, _rect2, _path4, _g17, _rect3, _path5, _g18, _rect4, _path6, _g19, _rect5, _path7, _g20, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 174",
    style: {
      enableBackground: "new 0 0 210 174"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#585E65;}\n\t.st1{fill:#9E9FA3;}\n\t.st2{fill:#08161F;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#9FA0A4;}\n\t.st5{fill:#E5E5E5;}\n\t.st6{fill:#C70502;}\n\t.st7{fill:#ECECEC;}\n\t.st8{fill:#323232;}\n\t.st9{fill:#FAFAFA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.1,138.5c-4,0-7.4-0.5-10.9-1.6c-2.8-0.9-5.4-2.7-7.4-5.1c-1.9-2.3-3-5-3-7.3c0-5.3,2.4-7.9,8.7-9.2 c5.9-1.2,18.1-2.3,18.6-2.4l0.1,1.4c-0.1,0-12.6,1.1-18.4,2.4c-5.6,1.2-7.6,3.2-7.6,7.8c0,3.9,3.8,9.3,9.4,11.1s11,2,19.7,0.9 c6-0.8,7.1-1.7,8-2.4c0.4-0.3,0.8-0.7,1.5-1l0.6,1.3c-0.5,0.2-0.9,0.5-1.2,0.8c-1.1,0.9-2.3,1.9-8.7,2.7 C47.9,138.2,44.9,138.5,42.1,138.5L42.1,138.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.7,163.7c-1.2,0-2.4-0.4-3.6-1.1c-1.4-0.8-2.5-1.9-3.1-2.5c-0.7-0.6-16.4-15.2-24-22.2 c-3.2-3-4.8-4.5-4.8-4.5c-0.4-0.4-4.1-3.9-9.2-2.1c-1.7,0.6-3.6,1.5-5.5,2.4c-4.7,2.3-10,4.9-16.3,4.5c-4.4-0.2-8.8-1.6-12.4-3.7 c-4.4-2.6-7.4-6.5-8.8-11.1c-0.8-2.5-0.6-4.4,0.4-5.9c1.8-2.6,5.7-3,9.6-3.4c1-0.1,2-0.2,2.9-0.3c0.4-0.1,51.7-5.8,57.6-6.5 l69.3-8.3c2-0.2,5.3-1.2,5.2-4.6c-0.1-1.6-0.6-2.9-1.6-3.7c-2-1.8-5.3-1.4-5.4-1.4l0,0c-0.2,0-22.8,0.4-49.9,0.8 c-41,0.7-91.4,1.5-98,1.5c-2.1,0-3.9-0.9-5.1-2.5c-1.3-1.8-1.6-4.2-0.9-6.5c1.1-3.4,4.2-5.1,8-4.3c1.5,0.3,2.9,1,4.2,1.7 c2.9,1.5,4.1,1.9,5.2,0.3c1.2-1.7,0-3.6-2-6.5c-0.3-0.4-0.6-0.9-0.9-1.4C20,63.9,20.9,55.3,22.5,48c3.3-14.7,13.3-18.9,19-20.2 c22.9-5,56.2-17.6,56.6-17.7c0.2-0.1,0.5-0.2,0.8-0.3c1.9-0.8,4.8-2,6.9-0.9c1,0.5,1.6,1.4,1.9,2.7c0.3,1.6,1,7.1,1.8,13.5 c1,8,2.1,17,2.8,20.7c0.9,4.8,3.8,13.4,11.9,16c7.2,2.3,14,1,18.2-3.4c4.1-4.3,9.1-8.8,17.7-7.4c5.1,0.8,8.3,4,11.1,7.4 c2,2.4,21.9,28.3,23.5,30.5c0.5,0.7,1.1,1.5,1.7,2.2c2.1,2.4,4.4,5.2,2.2,8.5c-1.5,2.2-2.7,4.7-4.1,7.6c-0.5,1.1-1.1,2.1-1.7,3.3 c-0.9,1.8-3.1,2.9-5.7,2.9c-1.4,0-28.3,0.3-31.5,0.4c-2.1,0.1-5.5,0.2-9.5,0.4c-9.2,0.4-21.8,0.9-29.4,1.4c-1.6,0.1-2.8,0.7-3,1.6 s0.6,2,2.2,3c0.7,0.4,1.3,0.8,1.9,1.2c5.4,3.4,10.6,6.6,11.2,13.1c0.7,7.7-2.3,24.6-12.2,29C116.1,163.6,115.4,163.7,114.7,163.7 L114.7,163.7z M72.8,128.7c4.4,0,7.4,2.8,7.8,3.2c0.1,0.1,2.1,1.9,4.8,4.4c22.3,20.6,24,22.3,24.1,22.4c0.9,0.9,3.9,3.9,6.5,2.7 c8.6-3.8,11.7-19.3,11-27c-0.5-5.5-5-8.3-10.2-11.5c-0.7-0.4-1.3-0.8-2-1.2c-3.4-2.2-3.2-4.3-3-5.2c0.4-1.8,2.3-2.9,4.8-3.1 c7.6-0.5,20.2-1,29.4-1.4c3.9-0.2,7.4-0.3,9.5-0.4c3.3-0.2,30.2-0.4,31.6-0.4c1.5,0,3.3-0.5,3.9-1.8c0.6-1.1,1.1-2.2,1.6-3.2 c1.4-2.8,2.7-5.5,4.2-7.8c1.3-1.9,0.1-3.5-2.1-6.1c-0.6-0.7-1.2-1.5-1.8-2.3c-1.4-2-21.6-28.1-23.4-30.4c-2.9-3.5-5.6-6-9.8-6.6 c-6.9-1.1-11.2,1.8-15.9,6.8c-2.2,2.4-5.3,4-8.7,4.7c-3.6,0.7-7.6,0.5-11.6-0.8c-9.2-2.9-12.3-12.2-13.3-17.5 c-0.8-3.8-1.8-12.9-2.8-20.9c-0.7-6.1-1.4-11.9-1.8-13.3c-0.2-1-0.7-1.3-0.8-1.4c-1.2-0.6-3.7,0.4-5.2,1c-0.3,0.1-0.6,0.3-0.9,0.4 C97.5,12.4,65,24.7,42,29.7c-5.2,1.1-14.5,5.1-17.5,18.6c-1.6,7.2-2.4,15,2.8,22.9c0.3,0.4,0.6,0.9,0.9,1.3c2,2.9,4,5.8,2,8.8 c-2.2,3.3-5.3,1.7-7.8,0.4c-1.2-0.6-2.4-1.3-3.6-1.5c-2-0.4-4.7-0.2-5.7,3c-0.5,1.6-0.3,3.4,0.6,4.6c0.6,0.8,1.6,1.7,3.5,1.7 c6.6,0,56.9-0.8,97.9-1.5v1v-1c26.6-0.4,48.8-0.8,49.9-0.8c0.5-0.1,4.3-0.3,6.8,1.9c1.4,1.2,2.2,3,2.3,5.2c0.1,3.6-2.5,6.1-7,6.6 h-0.2l0,0l-69.1,8.3c-0.6,0.1-56.8,6.4-57.5,6.5c-0.9,0.1-2,0.2-3,0.3c-3.2,0.3-6.9,0.7-8.1,2.5c-0.6,0.9-0.7,2.3-0.1,4.2 c1.3,4.2,3.9,7.6,7.9,10c3.3,2,7.3,3.2,11.5,3.4c5.7,0.3,10.8-2.1,15.3-4.3c2-1,3.9-1.9,5.7-2.5C70.6,128.9,71.7,128.7,72.8,128.7 L72.8,128.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5,
    cy: 85.7,
    r: 3.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M4,86.8h0.8v-2.1l0,0l-0.7,0.2L4,84.4l0.9-0.3h0.6v2.8h0.7v0.5H4V86.8z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 36.1,
    cy: 82.2,
    r: 3.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.1,83.3c0-0.7,0.2-1,0.7-1.1l0.4-0.1c0.3-0.1,0.4-0.2,0.4-0.5l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.7,0.1-0.8,0.2 l-0.1-0.5c0.2-0.1,0.6-0.2,1.1-0.2c0.7,0,1.1,0.3,1.1,1v0.1c0,0.6-0.2,0.8-0.7,1l-0.4,0.1c-0.4,0.1-0.5,0.3-0.5,0.5v0.2h1.5v0.5 h-2.2V83.3z"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 16,
    cy: 53,
    r: 3.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.9,54.5L15,54c0.2,0.1,0.6,0.2,0.9,0.2c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5h-0.4v-0.5h0.3 c0.4,0,0.6-0.1,0.6-0.4l0,0c0-0.3-0.2-0.4-0.5-0.4c-0.3,0-0.6,0.1-0.8,0.2l-0.2-0.5c0.3-0.1,0.7-0.2,1.1-0.2c0.6,0,1.1,0.2,1.1,0.8 v0.1c0,0.3-0.2,0.6-0.5,0.7l0,0c0.3,0.1,0.6,0.3,0.6,0.8v0.1c0,0.7-0.4,1-1.2,1C15.5,54.7,15.1,54.6,14.9,54.5z"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 110.2,
    cy: 4.9,
    r: 3.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.6,5.9H109V5.4l1.1-2.2h0.8l-1.1,2.1h0.8V4.4h0.7v0.9h0.4v0.6h-0.4v0.6h-0.7 C110.6,6.5,110.6,5.9,110.6,5.9z"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 129.8,
    cy: 57.2,
    r: 3.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131,57.7L131,57.7c0,0.8-0.4,1.1-1.2,1.1c-0.6,0-0.9-0.1-1.1-0.3l0.2-0.5c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5c-0.2,0-0.5,0-0.7,0l-0.1-0.2l0.1-1.6h1.8V56h-1.3l-0.1,0.7c0.1,0,0.2,0,0.3,0 C130.6,56.7,131,57,131,57.7z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 159.4,
    cy: 45.2,
    r: 3.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M160.7,45.8L160.7,45.8c0,0.7-0.4,1.1-1.2,1.1c-1,0-1.2-0.5-1.2-1.6v-0.1c0-1.4,0.5-1.7,1.3-1.7 c0.3,0,0.6,0.1,0.8,0.1l-0.1,0.5c-0.2-0.1-0.4-0.1-0.7-0.1c-0.4,0-0.6,0.1-0.7,0.8c0.2,0,0.4,0,0.6,0 C160.3,44.8,160.7,45,160.7,45.8z M160,45.8c0-0.4-0.1-0.5-0.5-0.5c-0.2,0-0.3,0-0.5,0c0,0.7,0.1,1,0.5,1 C159.8,46.4,160,46.2,160,45.8L160,45.8z"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 205,
    cy: 96.8,
    r: 3.5
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.5,95.7h-1.6v-0.5h2.3v0.5l-1.3,2.9h-0.8L205.5,95.7z"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 193.5,
    cy: 117.2,
    r: 3.5
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M194.8,117.9L194.8,117.9c0,0.7-0.4,1-1.2,1s-1.2-0.3-1.2-1l0,0c0-0.4,0.2-0.6,0.5-0.8 c-0.2-0.1-0.4-0.4-0.4-0.7l0,0c0-0.6,0.4-0.9,1.2-0.9c0.7,0,1.1,0.3,1.1,0.9l0,0c0,0.3-0.1,0.6-0.4,0.7 C194.6,117.3,194.8,117.5,194.8,117.9z M194.1,117.9c0-0.3-0.1-0.5-0.5-0.5l0,0c-0.3,0-0.5,0.1-0.5,0.5l0,0c0,0.3,0.1,0.5,0.5,0.5 C193.9,118.4,194.1,118.2,194.1,117.9L194.1,117.9z M193.1,116.4c0,0.3,0.1,0.4,0.4,0.4l0,0c0.3,0,0.4-0.2,0.4-0.4l0,0 c0-0.3-0.1-0.4-0.4-0.4C193.2,116,193.1,116.2,193.1,116.4L193.1,116.4z"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 106.1,
    cy: 117.7,
    r: 3.5
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M107.4,117.3v0.6c0,0.9-0.2,1.5-1.2,1.5c-0.4,0-0.7-0.1-1-0.1l0.1-0.6c0.2,0.1,0.6,0.1,0.8,0.1 c0.4,0,0.6-0.2,0.6-0.7c-0.2,0-0.4,0-0.6,0c-0.8,0-1.1-0.3-1.1-1.1v0c0-0.7,0.4-1.1,1.2-1.1C107,116,107.4,116.4,107.4,117.3z  M106.2,117.6c0.2,0,0.3,0,0.5,0v-0.1c0-0.7-0.1-1-0.5-1s-0.5,0.2-0.5,0.5l0,0C105.7,117.4,105.8,117.6,106.2,117.6z"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 133.4,
    cy: 128.7,
    r: 3.5
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131,129.8h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.8h0.7v0.5H131V129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.9,130.1c-0.2-0.2-0.3-0.6-0.3-1.4v-0.1c0-0.7,0.1-1.1,0.3-1.3c0.2-0.2,0.5-0.3,0.9-0.3 c0.5,0,0.7,0.1,0.9,0.3c0.2,0.3,0.3,0.6,0.3,1.3v0.1c0,0.8-0.1,1.1-0.3,1.3s-0.5,0.3-0.9,0.3C134.4,130.4,134.1,130.3,133.9,130.1z  M135.2,129.7c0.1-0.2,0.1-0.5,0.1-1v-0.1c0-0.5,0-0.8-0.1-1c-0.1-0.1-0.2-0.1-0.4-0.1s-0.3,0-0.4,0.1c-0.1,0.2-0.1,0.5-0.1,1v0.1 c0,0.5,0,0.8,0.1,1c0.1,0.1,0.2,0.2,0.4,0.2C135,129.8,135.1,129.8,135.2,129.7z"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 115.4,
    cy: 169.3,
    r: 3.5
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.1,170.4h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.8h0.7v0.5h-2.1v-0.6H113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.9,170.4h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.8h0.7v0.5H116v-0.6H115.9z"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 73.1,
    cy: 136.3,
    r: 3.5
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.8,137.4h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.8H73v0.5h-2.1v-0.6H70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.4,137.4c0-0.7,0.2-1,0.7-1.1l0.4-0.1c0.3-0.1,0.4-0.2,0.4-0.5l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.7,0.1-0.8,0.2 l-0.1-0.5c0.2-0.1,0.6-0.2,1.1-0.2c0.7,0,1.1,0.3,1.1,1v0.1c0,0.6-0.2,0.8-0.7,1l-0.4,0.1c-0.4,0.1-0.5,0.3-0.5,0.5v0.2h1.5v0.5 h-2.2V137.4z"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 48.8,
    cy: 145.5,
    r: 3.5
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.5,146.6h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3H48v2.8h0.7v0.5h-2.1v-0.6H46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.1,147l0.1-0.5c0.2,0.1,0.6,0.2,0.9,0.2c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5h-0.4v-0.5H50 c0.4,0,0.6-0.1,0.6-0.4l0,0c0-0.3-0.2-0.4-0.5-0.4s-0.6,0.1-0.8,0.2l-0.2-0.5c0.3-0.1,0.7-0.2,1.1-0.2c0.6,0,1.1,0.2,1.1,0.8v0.1 c0,0.3-0.2,0.6-0.5,0.7l0,0c0.3,0.1,0.6,0.3,0.6,0.8v0.1c0,0.7-0.4,1-1.2,1C49.7,147.2,49.3,147.2,49.1,147z"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 19.3,
    cy: 114,
    r: 3.5
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16.9,115.1h0.8V113l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6v2.8h0.7v0.5H17L16.9,115.1L16.9,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21,115h-1.6v-0.4l1.1-2.2h0.8l-1.1,2.1H21v-0.9h0.7v0.9h0.4v0.6h-0.4v0.6H21V115z"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 179.6,
    cy: 92.8,
    r: 3.5
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.2,93.9h0.8v-2.1l0,0l-0.7,0.2l-0.1-0.5l0.9-0.3h0.6V94h0.7v0.5h-2.1L177.2,93.9L177.2,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.2,93.3L182.2,93.3c0,0.8-0.4,1.1-1.2,1.1c-0.6,0-0.9-0.1-1.1-0.3l0.2-0.5c0.3,0.2,0.6,0.3,0.9,0.3 c0.4,0,0.6-0.1,0.6-0.5l0,0c0-0.4-0.2-0.5-0.6-0.5c-0.2,0-0.5,0-0.7,0l-0.1-0.2l0.1-1.6h1.8v0.5h-1.3l-0.1,0.7c0.1,0,0.2,0,0.3,0 C181.8,92.3,182.2,92.6,182.2,93.3z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 85.9,
    className: "st5",
    width: 0.7,
    height: 8.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M119.2,92.2h-8.5v7.8h8.5V92.2z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M112.3,94.6c0-0.6,0.3-0.9,0.9-0.9h2v0.8h-1.7c-0.1,0-0.2,0.1-0.2,0.2v0.9h1.8v0.8h-1.8v1.9h-1 C112.3,98.3,112.3,94.6,112.3,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M116.2,97.7v-4h1v3.8c0,0.1,0,0.1,0.1,0.1h1.4v0.8h-1.8C116.3,98.4,116.2,98.2,116.2,97.7z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 22,
    transform: "matrix(0.8831 -0.4692 0.4692 0.8831 -8.7155 20.4446)",
    className: "st7",
    width: 0.7,
    height: 11.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.6,18.6h-8.5l0,0v7.7h8.5V18.6z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.1,19.8h1v0.9h-1V19.8z M32.1,21.2H33v3.6h-0.9V21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M34.2,24h1.1v-3l0,0l-1,0.3l-0.2-0.8l1.3-0.4h0.9V24h1v0.8h-3L34.2,24L34.2,24z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3,
    y: 131.1,
    className: "st7",
    width: 0.7,
    height: 9.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.2,125.7h-8.5l0,0v7.7h8.5V125.7z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.6,127h1v0.9h-1V127z M46.7,128.3h0.9v3.6h-0.9V128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48.5,131.7l0.1-0.8c0.3,0.2,0.8,0.3,1.3,0.3c0.6,0,0.9-0.2,0.9-0.7v-0.1c0-0.5-0.3-0.7-0.8-0.7h-0.6v-0.8h0.4 c0.6,0,0.8-0.1,0.8-0.6v-0.1c0-0.4-0.3-0.5-0.7-0.5c-0.5,0-0.9,0.1-1.2,0.3l-0.2-0.8c0.4-0.2,0.9-0.3,1.5-0.3 c0.8,0,1.5,0.3,1.5,1.2v0.1c0,0.5-0.2,0.9-0.7,1l0,0c0.5,0.1,0.8,0.5,0.8,1.1v0.1c0,1-0.6,1.4-1.8,1.4 C49.4,132,48.9,131.9,48.5,131.7z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 179.7,
    y: 73.8,
    transform: "matrix(0.8001 -0.5999 0.5999 0.8001 -7.4837 125.9071)",
    className: "st7",
    width: 10.9,
    height: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.6,67.6h-8.5l0,0v7.7h8.5V67.6z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189.1,68.9h1v0.9h-1V68.9z M189.1,70.2h0.9v3.6h-0.9V70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M191.1,73c0-1,0.3-1.4,1.1-1.6l0.6-0.2c0.4-0.1,0.6-0.2,0.6-0.7l0,0c0-0.4-0.3-0.6-0.8-0.6s-0.9,0.1-1.2,0.3 l-0.2-0.8c0.3-0.2,0.9-0.3,1.5-0.3c0.9,0,1.6,0.4,1.6,1.4v0.1c0,0.8-0.3,1.2-1,1.4l-0.6,0.2c-0.5,0.1-0.7,0.4-0.7,0.8v0h2.2v0.8 h-3.1L191.1,73L191.1,73z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8,
    y: 86.8,
    className: "st7",
    width: 0.7,
    height: 7.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.9,93.2H54l0,0v6.4h5.9C59.9,99.7,59.9,93.2,59.9,93.2z"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M55.7,98.2l0.2-0.6c0.3,0.1,0.7,0.2,1,0.2c0.5,0,0.7-0.1,0.7-0.5l0,0c0-0.3-0.1-0.4-0.5-0.5l-0.4-0.1 c-0.7-0.2-1-0.4-1-1.1v-0.1c0-0.8,0.5-1.1,1.4-1.1c0.4,0,0.9,0.1,1.2,0.2l-0.2,0.7c-0.3-0.1-0.7-0.2-0.9-0.2c-0.4,0-0.6,0-0.6,0.4 l0,0c0,0.3,0.1,0.4,0.5,0.4l0.5,0.1c0.7,0.1,0.9,0.4,0.9,1.1v0.1c0,0.9-0.5,1.2-1.5,1.2C56.5,98.4,55.9,98.3,55.7,98.2z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 94.8,
    className: "st9",
    width: 0.9,
    height: 5.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 95.7,
    width: 0.9,
    height: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 97.4,
    width: 0.9,
    height: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 99.1,
    width: 0.9,
    height: 0.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 94.8,
    className: "st9",
    width: 0.9,
    height: 5.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 94.8,
    width: 0.9,
    height: 0.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 96.5,
    width: 0.9,
    height: 0.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 98.3,
    width: 0.9,
    height: 0.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 92.2,
    className: "st9",
    width: 0.9,
    height: 2.6
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 92.2,
    width: 0.9,
    height: 0.9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 109.8,
    y: 94,
    width: 0.9,
    height: 0.9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 92.2,
    className: "st9",
    width: 0.9,
    height: 2.6
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 93.1,
    width: 0.9,
    height: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.67be20a11db1c418caafe76031ef6201.svg";
export { ForwardRef as ReactComponent };